import './NewLoader.css'
interface NewLoaderProps {
    canvasHeight: any,
    canvasWidth: any,
    loaderpage: any
}

const NewLoader: React.FC<NewLoaderProps> = ({ canvasHeight, canvasWidth, loaderpage }) => {
    const style = {
        height: canvasHeight ? canvasHeight : '100vh',
        width: canvasWidth ? canvasWidth : '100wh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
    }

    return (
        <div className={loaderpage ? 'loader-page' : ''} style={style}>
            <div className='fetching_loader_model'>
            </div>
        </div>
    )
}

export default NewLoader